import { ChangeEvent } from 'react';

import Spinner from '@atlaskit/spinner';
import Textfield from '@atlaskit/textfield';

import { LoadingStatus } from 'src/constants/loading-status';
import { useIntl } from 'src/hooks/intl';
import { IssueType } from 'src/redux/jira/types';

import * as styles from './create-jira-issue-pr.styled';
import messages from './create-jira-issue.i18n';
import { IssueTypeChooser } from './issue-type-chooser';

type Props = {
  issueSummary: string;
  handleIssueSummaryChange: (e: ChangeEvent<HTMLInputElement>) => void;
  selectedIssueType: IssueType | undefined;
  handleSetSelectedIssueType: (issueType: IssueType | undefined) => void;
  isCreatingIssue: boolean;
  isInvalid: boolean;
  issueMeta: {
    issueTypes: IssueType[];
    fetchedStatus: LoadingStatus;
  };
};
export const CreateJiraIssueInput = ({
  issueSummary,
  handleIssueSummaryChange,
  selectedIssueType,
  handleSetSelectedIssueType,
  isCreatingIssue,
  isInvalid,
  issueMeta,
}: Props) => {
  const intl = useIntl();

  return (
    <Textfield
      autoFocus
      autoComplete="off"
      testId="create-jira-issue-textfield"
      value={issueSummary}
      onChange={handleIssueSummaryChange}
      placeholder={intl.formatMessage(messages.issueSummaryPlaceholder)}
      isDisabled={isCreatingIssue}
      isInvalid={isInvalid}
      elemBeforeInput={
        <IssueTypeChooser
          fetchedStatus={issueMeta.fetchedStatus}
          isDisabled={
            isCreatingIssue ||
            issueMeta.fetchedStatus === LoadingStatus.Forbidden
          }
          issueTypes={issueMeta.issueTypes || []}
          onSelectedChange={handleSetSelectedIssueType}
          selected={selectedIssueType}
        />
      }
      elemAfterInput={
        isCreatingIssue && (
          <styles.CreateIssueSpinnerWrapper>
            <Spinner size="small" />
          </styles.CreateIssueSpinnerWrapper>
        )
      }
    />
  );
};
